<span
  class="odilo-icons sidebar__hide hide-mobile"
  [class.show]="isSidebarOpen"
  [tabIndex]="isSidebarOpen ? 0 : -1"
  [attr.aria-label]="'general.close' | translate"
  [ngClass]="textDirection"
  (keydown.enter)="toggleSidebar()">
  {{defaultIconHide}}
</span>

<aside #aside class="sidebar" [class.open]="isSidebarOpen" [ngClass]="textDirection">
  <div class="searcher-sticky" [ngClass]="textDirection">
    <div class="mobile-filters hide-tablet" [ngClass]="textDirection">
      <h2>{{ 'sidebar.title' | translate }}</h2>
      <opac-button (click)="toggleSidebar()">
        <opac-icon icon="close" slot="only-icon"></opac-icon>
      </opac-button>
    </div>
    <app-search-bar (submitted)="onAction()" *ngIf="!hideButtonsSideMenu"></app-search-bar>
  </div>

  <div class="content">
    <app-search-terms *ngIf="!hideButtonsSideMenu" (submitted)="onAction()"></app-search-terms>
    <app-filters (submitted)="onAction()"></app-filters>
  </div>
</aside>

<span
  class="odilo-icons sidebar__hide transparent hide-mobile"
  (keydown.enter)="toggleSidebar()"
  (click)="toggleSidebar()"
  [class.show]="isSidebarOpen"
  [ngClass]="textDirection">
  {{defaultIconHide}}
</span>
